import React from 'react';
import { Wrapper, CenteredContainer, BigIcon, Title, Description } from '../StatusViews.styles';

export const Rejected = () => {
  return (
    <Wrapper>
      <CenteredContainer>
        <BigIcon className="far fa-times-circle" color="error.600" />
        <Title>New Account Application Rejected</Title>
        <Description>There was a problem opening the account.</Description>
      </CenteredContainer>
    </Wrapper>
  );
};
